import { datadogLogs, type StatusType } from '@datadog/browser-logs';
import { buildLoggerMessage, type Logger, type LoggerMessageBuilderParams } from '@fff-web/logger';

/**
 * Adapts the structured logger shape the shared libs use onto `datadogLogs.logger`,
 * which is what the rest of this app's effects already log through.
 */
const toDatadog =
  (level: Extract<StatusType, 'debug' | 'info' | 'warn' | 'error'>) =>
  (params: LoggerMessageBuilderParams, context?: object) => {
    const { error, ...rest } = (context ?? {}) as { error?: unknown };
    datadogLogs.logger[level](
      buildLoggerMessage(params),
      rest,
      error instanceof Error ? error : undefined,
    );
  };

export const datadogLogger: Logger = {
  debug: toDatadog('debug'),
  info: toDatadog('info'),
  warn: toDatadog('warn'),
  error: toDatadog('error'),
};
